import { Link } from 'react-router-dom';
import Seo from '../../components/common/Seo.jsx';

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <Seo fallback={{ title: 'Page not found', noindex: true }} />
      <h1 className="text-4xl font-bold text-slate-800 sm:text-5xl">404</h1>
      <p className="mt-2 text-sm text-slate-500 sm:text-base">
        The page you're looking for doesn't exist.
      </p>
      <Link to="/" className="mt-4 rounded-md bg-brand-500 px-4 py-2 text-sm text-white">
        Back home
      </Link>
    </div>
  );
}
